<template>
    <b-card :sub-title="'Datos del menor: ' + base.nombre + ' ' + base.apellidos">
        <b-card-text>
            <b-row>
                <div class="col-2" v-if="base.foto_perfil">
                    <b-img thumbnail fluid :src="base.foto_perfil" alt="Foto de perfil"></b-img>
                </div>
                <b-col md="12" lg="3">
                    <p><b>Nombre:</b> {{ base.nombre }}</p>
                    <p><b>Apellidos:</b> {{ base.apellidos }}</p>
                    <p><b>DNI:</b> {{ base.dni }}</p>
                    <p><b>Fecha de naciminento:<br></b> {{ base.fecha_de_nacimiento }}</p>
                </b-col>
                <b-col md="12" lg="3">
                    <p><b>Fecha de caducidad del DNI::<br></b> {{ base.fecha_de_caducidad_dni }}</p>
                    <p><b>Teléfono:</b> {{ base.telefono }}</p>
                    <p><b>Email:</b> {{ base.email }}</p>
                    <p><b>País de nacimiento:</b> {{ base.pais_de_nacimiento }}</p>
                </b-col>
                <b-col md="12" lg="3">
                    <p><b>Localidad de nacimiento:</b> {{ base.localidad_de_nacimiento }}</p>
                    <p><b>Provincia de nacimiento:</b> {{ base.provincia_de_nacimiento }}</p>
                    <p><b>Nacionalidad:</b> {{ base.nacionalidad }}</p>
                    <p><b>Dirección:</b> {{ base.direccion }}</p>
                </b-col>
                <b-col md="12" lg="3">
                    <p><b>Club de procedencia:</b> {{ base.club_de_procedencia }}</p>
                    <p><b>Lateralidad:</b> {{ base.lateralidad }}</p>
                    <p><b>Categoría:</b> {{ base.categoria }}</p>
                </b-col>
            </b-row>
        </b-card-text>
        <b-row>
            <b-col cols="12" v-if="base.categoria_base.representante">
                <b-card-sub-title>
                    Datos del entrenador:
                </b-card-sub-title>
                <b-card-text>
                    <p><b>Nombre:</b> {{ base.categoria_base.representante.name }}</p>
                    <p><b>Apellidos:</b> {{ base.categoria_base.representante.surnames }}</p>
                    <p><b>DNI:</b> {{ base.categoria_base.representante.nif }}</p>
                </b-card-text>
            </b-col>
            <b-col cols="3" v-if="base.equipo">
                <b-card-sub-title>
                    Datos del equipo:
                </b-card-sub-title>
                <b-card-text>
                    <p><b>Nombre:</b> {{ base.equipo.nombre }}</p>
                    <p><b>Edad Media:</b> {{ base.equipo.edad_media + ' años' }}</p>
                    <p><b>Entrenador:</b> {{ base.equipo.representante.name }}</p>
                </b-card-text>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
export default {
    props: ['base']
}    
</script>